import angular from 'angular'

import { RegisterManager } from '../managers/register-manager'

/**
 * Initialises the registerManager.
 *
 * @module webregister.resolvers.registerManagerResolver
 */
angular
  .module('webregister.resolvers')
  .factory(
    'registerManagerResolver',
    function (registerManager: RegisterManager) {
      return registerManager.init()
    }
  )
